'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@sprd/sprd-component-kit/v2';
import { useActionState, useState } from 'react';
import { useTranslations } from 'next-intl';
import { useImageBaseUrl } from '@/atoms/processEnvAtom';
import { RadioLinkItem } from '@/components/Filters/FilterContent';
import { RecaptchaWrapper } from '@/components/Recaptcha/RecaptchaWrapper';
import { ResponsiveDialog } from '@/components/ResponsiveDialog/ResponsiveDialog';
import { Locale } from '@/utility/locale';
import { type ReportDesignState, reportDesign } from '../actions/reportDesign';
type ReportDesignDialogProps = {
  compositionId: string;
  designId?: number;
  locale: Locale;
};
export const ReportDesignDialog = t0 => {
  const $ = _c(55);
  const {
    compositionId,
    designId,
    locale
  } = t0;
  const t = useTranslations();
  const [openDialog, setOpenDialog] = useState(false);
  const [selected, setSelected] = useState(null);
  const [comment, setComment] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [reportState, formAction] = useActionState(reportDesign, t1);
  const imageBaseUrl = useImageBaseUrl();
  const designImage = designId ? `${imageBaseUrl}/designs/${designId},width=178,height=178.jpg` : null;
  let t2;
  if ($[1] !== locale || $[2] !== t) {
    let t3;
    if ($[4] !== locale) {
      t3 = chunks => <a target="_blank" className="font-semibold underline" href={`https://help.spreadshirt.com/hc/${locale.toLowerCase()}/articles/206779259-Copyright-Information`}>{chunks}</a>;
      $[4] = locale;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = t.rich("mpDetailPage.reportDesign.reason.copyright", {
      link: t3
    });
    $[1] = locale;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      label: t2,
      value: "COPYRIGHT"
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t.rich("mpDetailPage.reportDesign.reason.guidelines", {
      link: _temp
    });
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      label: t4,
      value: "GUIDELINES"
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("mpDetailPage.reportDesign.reason.notForKids");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = {
      label: t6,
      value: "NOT_FOR_KIDS"
    };
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("mpDetailPage.reportDesign.reason.other");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = {
      label: t8,
      value: "OTHER"
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t3 || $[21] !== t5 || $[22] !== t7 || $[23] !== t9) {
    t10 = [t3, t5, t7, t9];
    $[20] = t3;
    $[21] = t5;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const reasons = t10;
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = value => {
      setSelected(value);
    };
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const onChange = t11;
  let t12;
  if ($[26] !== openDialog) {
    t12 = () => setOpenDialog(!openDialog);
    $[26] = openDialog;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("mpDetailPage.reportDesign.cta");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <Button variant="plain" className="!p-0 !font-normal text-black underline" size="m" onClick={t12}>{t13}</Button>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t) {
    t15 = t("mpDetailPage.reportDesign.title");
    $[33] = t;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = t("general.close");
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = open => setOpenDialog(open);
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== comment || $[39] !== compositionId || $[40] !== designImage || $[41] !== reasons || $[42] !== reportState.error || $[43] !== reportState.success || $[44] !== selected || $[45] !== t) {
    t18 = reportState.success ? <div className="px-4 py-6 md:px-8 lg:px-10"><p className="text-green-700">{t("mpDetailPage.reportDesign.success")}</p></div> : <form action={formAction} className="flex flex-col gap-4 px-4 sm:py-6 md:px-8 md:pt-3 lg:px-10 lg:pt-6 lg:pb-2"><input type="hidden" name="sourceEntityId" value={compositionId} /><input type="hidden" name="reason" value={selected || ""} /><div className="flex flex-col gap-6 sm:flex-row">{designImage ? <div><img src={designImage} alt="Design" className="size-[200px]" /></div> : null}<div><fieldset className="flex flex-col gap-4"><legend className="mb-3 text-sm font-semibold">{t("mpDetailPage.reportDesign.reasonHeading")}</legend>{reasons.map(reason => {
              const isSelected = selected === reason.value;
              return <label key={reason.value} className="flex items-center gap-2"><RadioLinkItem key={reason.value} variant="radio-group" checked={isSelected} onChange={() => onChange(reason.value)}>{reason.label}</RadioLinkItem></label>;
            })}</fieldset></div></div><div><label htmlFor="comment" className="text-sm font-semibold">{t("mpDetailPage.reportDesign.descriptionHeading")}</label><textarea id="comment" name="comment" className="mt-1 w-full rounded border border-neutral-300 p-2 text-sm focus:border-blue-500 focus:outline-none" rows={4} value={comment} onChange={e => setComment(e.target.value)} /></div><RecaptchaWrapper action="report_design_form" />{reportState.error && <div className="text-sm text-red-600">{t("mpDetailPage.reportDesign.error")}</div>}<div className="mt-4 mb-6 flex gap-2 sm:mb-0 sm:justify-end sm:gap-0"><Button type="button" variant="invert" className="flex-1 sm:flex-none" onClick={() => setOpenDialog(false)}>{t("general.cancel")}</Button><Button type="submit" variant="primary" className="flex-1 sm:flex-none">{t("mpDetailPage.reportDesign.reportBtnLabel")}</Button></div></form>;
    $[38] = comment;
    $[39] = compositionId;
    $[40] = designImage;
    $[41] = reasons;
    $[42] = reportState.error;
    $[43] = reportState.success;
    $[44] = selected;
    $[45] = t;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== openDialog || $[48] !== t15 || $[49] !== t16 || $[50] !== t18) {
    t19 = <ResponsiveDialog dismissible={true} className="md:max-w-2/3 lg:max-w-1/2" open={openDialog} title={t15} closeLabel={t16} onOpenChange={t17}>{t18}</ResponsiveDialog>;
    $[47] = openDialog;
    $[48] = t15;
    $[49] = t16;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== t14 || $[53] !== t19) {
    t20 = <>{t14}{t19}</>;
    $[52] = t14;
    $[53] = t19;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  return t20;
};
function _temp(chunks_0) {
  return <>{chunks_0}</>;
}